// 1:1 port of prototype/components/core/Panel.jsx (design D3): same name, same
// prop contract (prototype/components/core/Panel.d.ts), styled only from token
// CSS vars. UI.md §7 groups `Panel`/`Sheet` as one kit component pair (they ship
// from the one kit file); the client ports `Sheet` as its own module —
// `./Sheet.tsx` (task 6.2, design.md's module layout).

import type { CSSProperties, ReactNode } from 'react';

export interface PanelProps {
  /** Micro-caps header label. */
  title?: string;
  /** Right-aligned header node (e.g. a ghost Button). */
  action?: ReactNode;
  /** Recessed paper-1 background, no border/shadow. */
  sunken?: boolean;
  children?: ReactNode;
  style?: CSSProperties;
}

export function Panel({ title, action, sunken, children, style }: PanelProps) {
  return (
    <div
      data-ui="panel"
      data-ui-panel={sunken ? 'sunken' : 'raised'}
      style={{
        background: sunken ? 'var(--surface-sunken)' : 'var(--surface-card)',
        borderRadius: 'var(--r-lg)',
        border: sunken ? 'none' : '1px solid var(--line)',
        boxShadow: sunken ? 'none' : 'var(--panel-shadow, var(--shadow-card))',
        padding: 'var(--sp-4)',
        ...style,
      }}
    >
      {(title || action) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 'var(--sp-3)',
          }}
        >
          <div
            style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 800,
              fontSize: 11,
              textTransform: 'uppercase',
              letterSpacing: 'var(--tracking-caps)',
              color: 'var(--text-muted)',
            }}
          >
            {title}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
